import { CSSObject } from "@emotion/react";

export const confirmModalStyles = (): {
  [key: string]: Record<string, CSSObject | string | number>;
} => ({
  backdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modalContainer: {
    background: "#fff",
    borderRadius: 12,
    padding: "24px 16px 0",
    // width: 320,
    minWdth: "300px",
    maxWidth: "400px",
    textAlign: "center",
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
    fontFamily: "Gilroy-Regular",
  },
  description: {
    fontSize: 14,
    color: "#666",
    marginBottom: 16,
    lineHeight: 1.5,
    fontFamily: "Gilroy-Regular",
  },
  actionContainer: {
    display: "flex",
    borderTop: "1px solid #E0E0E0",
    marginTop: 16,
  },
  cancelButton: {
    flex: 1,
    padding: "12px 0",
    border: "none",
    borderRight: "1px solid #E0E0E0",
    background: "transparent",
    fontWeight: 500,
    cursor: "pointer",
    outline: "none",
    fontFamily: "Gilroy-Regular",
  },
  confirmButton: {
    flex: 1,
    padding: "12px 0",
    background: "transparent",
    fontWeight: 500,
    cursor: "pointer",
    outline: "none",
    border: "none",
    fontFamily: "Gilroy-Regular",
  },
});
